"use strict";
module.exports = {
    AHM_FACEBOOK: 'https://www.facebook.com/ahm.health.insurance',
    AHM_INSTAGRAM: 'https://instagram.com/ahmhealthinsurance',
    AHM_TWITTER: 'https://twitter.com/ahmhealth',
    AHM_YOUTUBE: 'https://youtube.com/user/AHMinsurance',
};
